module.exports = __webpack_public_path__ + "static/media/foam-arrow.ec5f8288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foam-arrow.svg
// module id = 70
// module chunks = 0